<template>
  <svg width="53"
       height="52"
       viewBox="0 0 53 52"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd"
          clip-rule="evenodd"
          d="M26.5 52C12.1406 52 0.5 40.3594 0.5 26C0.5 11.6406 12.1406 0 26.5 0C40.8594 0 52.5 11.6406 52.5 26C52.5 40.3594 40.8594 52 26.5 52ZM14.6375 22.2625L13.5 20.8C13.5 20.8 17.8875 15.6 21.3 14.95C24.1346 14.3058 24.7216 18.0544 25.2482 21.4168C25.3858 22.2951 25.5192 23.1471 25.6875 23.8875C26.5 27.1375 27.15 29.0875 27.8 29.0875C28.45 29.0875 29.9125 27.1375 31.375 24.375C33 21.45 31.375 19.0125 28.6125 20.8C29.75 13.65 40.9625 12.025 39.5 20.15C38.0375 28.4375 29.9125 35.2625 27.475 36.8875C25.0375 38.5125 22.7625 36.2375 21.95 34.6125C21.6084 33.7928 20.8936 31.4797 20.1313 29.0134C19.0803 25.6129 17.9393 21.9209 17.5625 21.45C16.75 20.475 14.6375 22.2625 14.6375 22.2625Z"
          fill="currentColor" />
  </svg>
</template>
